module.exports = require('./transaction');

module.exports.Input = require('./input');
module.exports.Output = require('./output');
module.exports.UnspentOutput = require('./unspentoutput');
module.exports.Signature = require('./signature');
module.exports.Sighash = require('./sighash');



//////////////////
// WEBPACK FOOTER
// ./node_modules/bitcore-lib/lib/transaction/index.js
// module id = lwos
// module chunks = 0